(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileOffice365EmailsEmailSplittedEmails', ["path", "$q", "$timeout", "emailDao", "widgetPolling", "tablePaginationHelper", "columnsHelper", function (path, $q, $timeout, emailDao, widgetPolling, tablePaginationHelper, columnsHelper) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/office365_emails_email/splitted-emails').template('splitted-emails'),
            scope: { shared: '=?profileOffice365EmailsEmailSplittedEmails' },
            link: function ($scope, element, attrs) {
                var id = widgetPolling.scope().id;
                $scope.options = {
                    options: {
                        defaultOrdering: {
                            columnName: 'user_email',
                            order: 'desc'
                        },
                        autoUpdate: 90000
                    },
                    columns: [
                        {
                            id: 'entity_id',
                            hidden: true,
                            primary: true
                        },
                        {
                            id: 'master_email',
                            hidden: true
                        },
                        {
                            id: 'user_id',
                            hidden: true
                        },
                        {
                            id: 'user_email',
                            text: 'Mailbox',
                            href: {
                                type: 'user',
                                params: { id: 'user_id' }
                            }
                        },
                        {
                            id: 'is_deleted_message',
                            hidden: true
                        },
                        {
                            id: 'is_quarantined',
                            text: 'Quarantined',
                            converter: 'booleanCheckConverter',
                            converterArgs: { showTimesMark: true },
                            dataClass: 'justify-center'
                        },
                        {
                            id: 'is_restored_from_quarantine',
                            text: 'Restored',
                            converter: 'booleanCheckConverter',
                            converterArgs: { showTimesMark: true },
                            dataClass: 'justify-center'
                        },
                        {
                            id: 'is_restore_declined',
                            hidden: true
                        }
                    ]
                };
                $scope.tableOptions = {
                    asDivs: true,
                    disableTop: true,
                    disableTotalRows: true,
                    dropdownHeader: true,
                    infinite: true,
                    orderDisplayMode: 'highlight-column',
                    pagesAround: 2,
                    pagination: {
                        pageSize: 20,
                        ordering: {}
                    },
                    reloadUuid: true,
                    saveState: true,
                    showWorkingIndicator: false,
                    workingIndicatorDisableGui: false
                };
                // getting Total rows
                var timeoutGetTotal = $q.defer();
                emailDao.getTotalSplittedEmails(id).timeout(timeoutGetTotal.promise).then(function (res) {
                    $scope.loadingInfoText = false;
                    $scope.tableOptions.infoText = '#' + JSON.stringify({
                        display: 'text',
                        'class': 'splitted-emails-table-title',
                        text: 'Delivered to the following mailboxes (' + (res.data.total_rows || 0) + ')'
                    });
                    $scope.shared.showSplitWidget = !!res.data.total_rows;
                }).catch(function () {
                    $scope.loadingInfoText = false;
                    $scope.tableOptions.infoText = '#' + JSON.stringify({
                        display: 'text',
                        'class': 'splitted-emails-table-title',
                        text: 'Delivered to the following mailboxes'
                    });
                    $scope.shared.showSplitWidget = false;
                });
                $timeout(function () {
                    timeoutGetTotal.resolve();
                }, 10000);
                $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                    var q = emailDao.splittedEmailsList($scope.options.columns, id);
                    if (args.columnsFilters) {
                        q.params(columnsHelper.filtersToParams(args.columnsFilters));
                    }
                    return q.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order);
                }, function (tableModel) {
                    $scope.tableModel = tableModel;
                });
            }
        };
    }]);
}());